export default "__VITE_ASSET__BemnJpoW__"